export default function(SomeComponent) {
  return SomeComponent.displayName || SomeComponent.name || "Component"
}
